import ServiceLocator from "../../global/service-locator";
import Footer from "../../global/footer";
import SprintHeader from "./header";
import lozadObserver from "../../extensions/lozad";
import Api from "../../lib/api";
import Consent from "../../components/consent";
export default class CoreModule {
    constructor() {
        this.sl = ServiceLocator.instance;
        this.header = new SprintHeader();
        this.footer = new Footer();

        this.initLozad();
        this.initAnalytics();
        this.initConsent();
    }

    initLozad() {
        lozadObserver();
    }

    initAnalytics() {
        const $lmsLinks = document.querySelectorAll('a[href^="https://lms.ithillel.ua"]');

        $lmsLinks.forEach(($lmsLink) => {
            $lmsLink.href = Api.updateUrlWithUtmTagQueryParams($lmsLink.href);
        });
    }

    initConsent() {
        new Consent();
    }
}